import styled, { css } from 'styled-components';
export const Label = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0 6px;
`;
export const RadioInput = styled.input`
  display: grid;
  place-content: center;
  /* Remove most all native input styles */
  appearance: none;
  /* For iOS < 15 */
  background-color: var(--form-background);
  /* Not removed via appearance */
  margin: 0;
  font: inherit;
  color: rgba(53, 59, 96, 1);
  width: 20px;
  height: 20px;
  border: 0.15em solid rgba(53, 59, 96, 0.35);
  border-radius: 50%;
  transform: translateY(-0.075em);
  cursor: pointer;
  ${props => props.selected && !props.disabled && css`
      border: 0.15em solid rgba(53, 59, 96, 1);
      color: rgba(53, 59, 96, 1);
    `}

  ${props => !props.disabled && css`
      &:hover,
      &:checked {
        border: 0.15em solid rgba(53, 59, 96, 1);
        color: rgba(53, 59, 96, 1);
      }
    `}

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    background: rgba(53, 59, 96, 1);
    ${props => props.selected && !props.disabled && 'transform: scale(1)'}
  }

  &:checked::before {
    transform: scale(1);
  }

  ${props => props.disabled && css`
      pointer-events: none;
      cursor: default;
    `}

  ${props => !props.disabled && props.color && css`
      && {
        &:hover,
        &:checked {
          border: 0.15em solid ${props.color};
          color: rgba(53, 59, 96, 1);
        }

        ${props => props.selected && !props.disabled && css`
            border: 0.15em solid ${props.color};
            color: ${props.color};
          `}

        &::before {
          background: ${props.color};
        }
      }
    `}
`;
export const Text = styled.div`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.15px;
  color: #00003d;
  cursor: pointer;
  user-select: none;
`;